import { beginningOfToday, addDays, isSameDay } from 'lib/datetime/dateUtils'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'

export function getMatchingFilterFromRange(from?: string, to?: string): Experiences.DateFilter | undefined {
  if (!from || !to) return undefined
  const fromDate = moment(from, ISO_DATE_FORMAT).toDate()
  const toDate = moment(to, ISO_DATE_FORMAT).toDate()
  const today = beginningOfToday()
  const tomorrow = addDays(today, 1)

  if (isSameDay(fromDate, today) && isSameDay(toDate, today)) return 'today'
  if (isSameDay(fromDate, tomorrow) && isSameDay(toDate, tomorrow)) return 'tomorrow'

  const fromMoment = moment(from, ISO_DATE_FORMAT)
  const toMoment = moment(to, ISO_DATE_FORMAT)
  const fromDay = fromMoment.day()
  const toDay = toMoment.day()
  const diffDays = toMoment.diff(fromMoment, 'days')
  const upcomingWeekendCutoff = addDays(today, 7)
  const isUpcomingWeekend = fromDate <= upcomingWeekendCutoff
  if ((fromDay === 5 || fromDay === 6) && (toDay === 6 || toDay === 0) && diffDays >= 1 && diffDays <= 2 && isUpcomingWeekend) return 'this-weekend'

  return undefined
}
